export default __webpack_public_path__ + "static/media/chair.ad297a2f.png";